/** Страница 404 и резервната страница на домейна за плащания. */
export default {
  title: "Тази страница все още не е генерирана",
  subtitle: "Разкажете ми повече за тази страница, за да я генерирам",
  payHost: {
    title: "Плащания AIStyle",
    body: "Тази страница служи за завършване на плащане. Отворете линка, който сте получили.",
  },
};
